function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Skeleton, Button, Tag, Modal, Space, notification, Drawer, Image, QRCode } from 'antd';
import Common from "./includes/Common";
import Moment from 'react-moment';
import { useOutletContext } from "react-router-dom";
import { NodePlusFill, TicketPerforatedFill, GeoAltFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var TicketViewCardTwoTone = function TicketViewCardTwoTone(_ref) {
  var ticket = _ref.ticket;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              minHeight: '150px'
            },
            children: /*#__PURE__*/_jsxs(Space.Compact, {
              className: "ticket-box",
              style: {
                background: ticket.price_schema_item.color
              },
              children: [/*#__PURE__*/_jsxs(Row, {
                style: {
                  padding: "12px"
                },
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 3,
                  sm: 3,
                  xs: 3,
                  children: ticket.event && /*#__PURE__*/_jsx(Image, {
                    preview: false,
                    src: Common.baseUrl + ticket.event.image_file,
                    style: {
                      width: "100%",
                      borderRadius: "8px"
                    }
                  })
                }), /*#__PURE__*/_jsxs(Col, {
                  lg: 9,
                  md: 9,
                  sm: 9,
                  xs: 9,
                  children: [/*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 5,
                      xs: 5,
                      children: /*#__PURE__*/_jsx(Tag, {
                        style: {
                          marginBottom: "8px"
                        },
                        color: ticket.price_schema_item.color,
                        children: /*#__PURE__*/_jsxs("b", {
                          children: [ticket.price_schema_item.label, "-", ticket.price_schema_item.price.toLocaleString('Fr'), " GNF"]
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: {
                        span: 4,
                        offset: 4
                      },
                      md: {
                        span: 4,
                        offset: 4
                      },
                      sm: {
                        span: 4,
                        offset: 3
                      },
                      xs: {
                        span: 5,
                        offset: 2
                      },
                      children: /*#__PURE__*/_jsx(Image, {
                        width: "80px",
                        preview: false,
                        src: "/drawables/nl1_rm.png"
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h6", {
                          style: {
                            color: "#F3F1EE"
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: ticket.event.label
                          })
                        }), /*#__PURE__*/_jsxs(Space, {
                          direction: "horizontal",
                          children: [/*#__PURE__*/_jsx("div", {
                            style: _defineProperty(_defineProperty({
                              color: "#F3F1EE",
                              fontSize: "17px",
                              fontWeight: "bold",
                              padding: "8px",
                              borderRadius: "4px"
                            }, "color", "#FFFFFF"), "background", "#EB9800"),
                            children: new Date(ticket.event.starts_at).getDay()
                          }), /*#__PURE__*/_jsxs("h6", {
                            style: {
                              color: "#F3F1EE"
                            },
                            children: [/*#__PURE__*/_jsxs("b", {
                              children: [new Date(ticket.event.starts_at).toLocaleDateString('Fr', {
                                month: 'long'
                              }), " ", new Date(ticket.event.starts_at).getFullYear()]
                            }), " - ", /*#__PURE__*/_jsx(GeoAltFill, {
                              size: 23
                            }), " ", ticket.event.place]
                          })]
                        })]
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#F3F1EE",
                  borderRadius: "4px",
                  padding: "8px 4px 4px 4px"
                },
                children: /*#__PURE__*/_jsx(QRCode, {
                  size: 120,
                  value: ticket.id.toString()
                })
              })]
            })
          })
        })
      })
    })
  });
};
export default TicketViewCardTwoTone;